import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AutoconsumoMotivoPedidoService} from "../../../../services/autoconsumo-motivo-pedido.service";
import {DatosMaestrosService} from "../../../../../../services/datos-maestros.service";
import {UtilsService} from "../../../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {forkJoin, Subscription} from "rxjs";
import {moduloAutoconsumo} from "../../../../diccionarios/autoconsumoModulo";
import {MantenedorSolicitudPedidoVentaService} from "../../../../services/mantenedor-solicitud-pedido-venta.service";
import {Material} from "../../../../../portfolio/interfaces/material.interface";

@Component({
  selector: 'app-linea-detalle',
  templateUrl: './linea-detalle.component.html',
  styleUrls: ['./linea-detalle.component.css']
})
export class LineaDetalleComponent implements OnInit, OnDestroy {
  mostrarGridLista: boolean = true;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formularioLineaDetalle: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  cmbUnidadMedida: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  subscription1$: Subscription;
  subscription2$: Subscription;
  subscription3$: Subscription;
  @Input() solicitudData: any;
  imputacionArray: any[];


  constructor(
    private fb: FormBuilder,
    private _autoconsumoMotivoPedidoService: AutoconsumoMotivoPedidoService,
    private _mantenedorSolicitudPedidoVentaService: MantenedorSolicitudPedidoVentaService,
    private _datosMaestrosService: DatosMaestrosService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }

  ngOnDestroy(): void {
    this.subscription1$ && this.subscription1$.unsubscribe();
    this.subscription2$ && this.subscription2$.unsubscribe();
    this.subscription3$ && this.subscription3$.unsubscribe();
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_TITULOS = moduloAutoconsumo.titulos.autoconsumoMotivoPedido;
    this.DAT_BTNCSS = moduloAutoconsumo.button.buttonsCss;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.textBoton = moduloAutoconsumo.button.buttonsNombre.agregar;
    this.formularioLineaDetalle = this.fb.group({
      idMaterial: ['', [Validators.required]],
      dscaMaterial: ['', [Validators.required]],
      cantidad: ['', [Validators.required]],
      idPedido: [null],
      idUnidad: ['', [Validators.required]],
      importe: ['', [Validators.required]],
      posicion: ['', [Validators.required]],
      precio: ['', [Validators.required]],
      lsPedidoImputacion: [[]],
    });
    this.formatInitInformation(this.solicitudData);
    this.girdComponent();
    //console.log(this.solicitudData);
    this.formularioLineaDetalle.get('cantidad').valueChanges.subscribe(nuevoValor => {
      this.changeCantidad();
    });
    this.subscription1$ = this._mantenedorSolicitudPedidoVentaService.materialSelectedListener().subscribe(data => {
      //console.log(data);
      this.materialSelected(data);
    });
    this.subscription2$ = this._mantenedorSolicitudPedidoVentaService.imputacionListener().subscribe(data => {
      //console.log('imputacionRegresarListener', data);
      if (data.action === 'nuevo' || data.action === 'editar') {
        this.rowData = data.result;
        this.imputacionArray = data.result;
      }
      this.mostrarGridLista = true;
    });
  }

  formatInitInformation(solicitudData) {
    //console.log(solicitudData);
    if (solicitudData && solicitudData.lineaDetalleEvent && solicitudData.lineaDetalleEvent === 'nuevo') {
      if (solicitudData && solicitudData.lineaDetalleArray) {
        this.formularioLineaDetalle.get('posicion').setValue(solicitudData.lineaDetalleArray ? solicitudData.lineaDetalleArray.length + 1 : 1);
      }
      if (solicitudData && solicitudData.idPedido) {
        this.formularioLineaDetalle.get('idPedido').setValue(solicitudData.idPedido);
      }
    } else {
      this.formularioLineaDetalle.get('idMaterial').setValue(solicitudData.data.idMaterial);
      this.formularioLineaDetalle.get('dscaMaterial').setValue(solicitudData.data.dscaMaterial);
      this.formularioLineaDetalle.get('cantidad').setValue(solicitudData.data.cantidad);
      this.formularioLineaDetalle.get('idPedido').setValue(solicitudData.data.idPedido);
      this.formularioLineaDetalle.get('idUnidad').setValue(solicitudData.data.idUnidad);
      this.formularioLineaDetalle.get('importe').setValue(solicitudData.data.importe);
      this.formularioLineaDetalle.get('posicion').setValue(solicitudData.data.posicion);
      this.formularioLineaDetalle.get('precio').setValue(solicitudData.data.precio);
      this.formularioLineaDetalle.get('lsPedidoImputacion').setValue(solicitudData.data.lsPedidoImputacion);
      this.getFormInfo();
    }
    this.imputacionArray = this.formularioLineaDetalle.get('lsPedidoImputacion').value;
    solicitudData.imputacionArray = this.formularioLineaDetalle.get('lsPedidoImputacion').value;
    this.rowData = this.imputacionArray;
    this.solicitudData.detallePosicion = this.formularioLineaDetalle.get('posicion').value;
  }

  getFormInfo() {
    if (this.formularioLineaDetalle && this.formularioLineaDetalle.get('idMaterial') && this.formularioLineaDetalle.get('idMaterial').value && this.formularioLineaDetalle.get('idMaterial').value !== '') {
      this.loading = true;
      const _getAllUnidadMedida = this._datosMaestrosService.getMaterialPresentacionByMaterial(this.formularioLineaDetalle.get('idMaterial').value);


      forkJoin([_getAllUnidadMedida]).subscribe((res: any) => {
        res[0].map(unidadMedida => {
          unidadMedida.id = unidadMedida.idUnidad;
          unidadMedida.descripcion = unidadMedida.idUnidad;
        });

        this.cmbUnidadMedida = res[0];
        this.loading = false;
      }, () => {
        this.loading = false;
        this.cmbUnidadMedida = [];
      });
    }
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'TIPO IMPUTACION',
        field: 'tipoImputacionDescripcion',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'ELEMENTO',
        field: 'elemento',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'DESCRIPCION',
        field: 'descElemento',
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'VALOR',
        field: 'importeImputacion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'PORCENTAJE',
        field: 'porcentaje',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarImputacion.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarImputacion({rowData}) {
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;
    this.solicitudData.imputacionEvent = 'editar';
    this.solicitudData.imputacionArray = this.imputacionArray;
    this.solicitudData.data = rowData;
    this.solicitudData.formularioLineaDetalle = this.formularioLineaDetalle.value;
  }

  nuevo() {
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.solicitudData.imputacionEvent = 'nuevo';
    this.solicitudData.imputacionArray = this.imputacionArray;
    this.solicitudData.formularioLineaDetalle = this.formularioLineaDetalle.value;
    //console.log(this.solicitudData);
  }

  eliminar({rowData}) {
    this.rowData = this.eliminarObjetoYActualizarIndex(this.rowData, rowData);
    this.imputacionArray = this.rowData;
    this.solicitudData.imputacionArray = this.imputacionArray;
    //console.log(this.rowData);
  }

  eliminarObjetoYActualizarIndex(arr: any[], objToDelete: any): any[] {
    const newArray = arr.filter((item) => item !== objToDelete);
    const updatedArray = newArray.map((item, index) => ({
      ...item,
      lineaImputacion: index + 1,
    }));
    return updatedArray;
  }


  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        const totalPorcentaje = this.calcularTotalPorcentaje(this.imputacionArray);
        if (totalPorcentaje !== 100) {
          this._util.mensajeErroToast('El porcentaje total debe ser 100%', 5000);
          return;
        }
        this.agregar();
      }
    } else {
      this.regresar();
    }
  }

  calcularTotalPorcentaje(imputacionArray) {
    let totalPorcentaje = 0;
    imputacionArray.forEach((imputacion: any) => {
      if (imputacion && imputacion.porcentaje && imputacion.porcentaje !== '') {
        totalPorcentaje = totalPorcentaje + parseFloat(String(imputacion.porcentaje));
      }
    });
    return totalPorcentaje;
  }

  agregar() {
    //console.log('prueba Alfredo');
    this.formularioLineaDetalle.get('lsPedidoImputacion').setValue(this.imputacionArray);
    if (this.solicitudData && this.solicitudData.lineaDetalleEvent && this.solicitudData.lineaDetalleEvent === 'nuevo') {
      this.solicitudData.lineaDetalleArray.push(this.formularioLineaDetalle.value);
      this._mantenedorSolicitudPedidoVentaService.lineaDetalleEvent({
        action: 'nuevo',
        result: this.solicitudData.lineaDetalleArray
      });
    } else if (this.solicitudData && this.solicitudData.lineaDetalleEvent && this.solicitudData.lineaDetalleEvent === 'editar') {
      const newArrayLineaDetalle = this.solicitudData.lineaDetalleArray.map((item) =>
        item.posicion === this.formularioLineaDetalle.get('posicion').value ? this.formularioLineaDetalle.value : item
      );
      this._mantenedorSolicitudPedidoVentaService.lineaDetalleEvent({
        action: 'editar',
        result: newArrayLineaDetalle
      });
    }
    this.formularioLineaDetalle.reset();
  }


  regresar() {
    //console.log('prueba Alfredo');
    this.formularioLineaDetalle.reset();
    this.imputacionArray = [];
    this._mantenedorSolicitudPedidoVentaService.lineaDetalleEvent({
      action: 'regresar',
      result: ''
    });
  }


  materialSelected(material: Material) {
    this.formularioLineaDetalle.get('idMaterial').setValue(material.idMaterial);
    this.formularioLineaDetalle.get('dscaMaterial').setValue(material.idMaterial + ' | ' + material.dscaMaterial);
    this.getFormInfo();
  }

  changeUnidad() {
    if (this.formularioLineaDetalle && this.formularioLineaDetalle.get('idUnidad') && this.formularioLineaDetalle.get('idUnidad').value && this.formularioLineaDetalle.get('idUnidad').value !== '') {
      this.loading = true;
      let payload2 = {
        idOrgaVenta: this.solicitudData.formularioSolicitudPedidoVenta.idOrgaVenta,
        idCanalVenta: this.solicitudData.formularioSolicitudPedidoVenta.idCanalVenta,
        idGrupoCliente: this.solicitudData.formularioSolicitudPedidoVenta.idGrupoCliente,
        idOficinaVenta: this.solicitudData.formularioSolicitudPedidoVenta.idOficinaVenta,
        idCliente: this.solicitudData.formularioSolicitudPedidoVenta.idCliente,
        idMaterial: this.formularioLineaDetalle.get('idMaterial').value,
        idUnidad: this.formularioLineaDetalle.get('idUnidad').value
      }
      //console.log(payload2);
      let payload = {
        idOrgaVenta: '1001',
        idCanalVenta: '10',
        idGrupoCliente: '-',
        idOficinaVenta: '-',
        idCliente: '-',
        idMaterial: '100000038',
        idUnidad: 'UN'
      }
      this._datosMaestrosService.getPrecioByQueryParams(payload2).subscribe((res: any) => {
        //console.log(res);
        if (res && res.length > 0) {
          this.formularioLineaDetalle.get('precio').setValue(res[0].precio)
        } else {
          this.formularioLineaDetalle.get('precio').setValue(0)
        }
        this.formularioLineaDetalle.get('cantidad').setValue(0)
        this.loading = false;
      }, () => {
        this.formularioLineaDetalle.get('precio').setValue(0)
        this.formularioLineaDetalle.get('cantidad').setValue(0)
        this.loading = false;
      });
    }
  }

  changeCantidad() {
    if (this.formularioLineaDetalle && this.formularioLineaDetalle.get('cantidad') && this.formularioLineaDetalle.get('cantidad').value && this.formularioLineaDetalle.get('cantidad').value !== '') {
      this.formularioLineaDetalle.get('importe').setValue(this.formularioLineaDetalle.get('cantidad').value * this.formularioLineaDetalle.get('precio').value)
    } else {
      this.formularioLineaDetalle.get('importe').setValue(0)
    }
  }
}
